import { FormGroup, FormArray, AbstractControl, ValidatorFn, AsyncValidatorFn } from '@angular/forms';
import { FormAdapterBase } from './form-adapter-base';

export class EnhancedFormGroup<T extends FormGroup | FormArray> extends FormGroup {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private adapters: FormAdapterBase<T, any>[] = [];

    public constructor(
        controls: { [key: string]: AbstractControl },
        validatorOrOpts?: ValidatorFn | ValidatorFn[] | null,
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
    ) {
        super(controls, validatorOrOpts, asyncValidator);
    }

    public applyAdapters(): void {
        this.adapters.forEach(adapter => adapter.apply());
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public registerAdapter(adapter: FormAdapterBase<T, any>): void {
        this.adapters.push(adapter);
    }
}
